import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PatientLoader from "../../../common/PatientLoader";
import {
  fetchLiveClassesEnrollmentLogic,
  fetchLiveClassesLogic,
} from "../../../../store/features/ops/opsSlice";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "../../../common/Helmet";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/TestAccounts.svg";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import ClassEnrollmentsDataTable from "./ClassEnrollmentsDataTable";

const ClassEnrollments = () => {
  const dispatch = useDispatch();
  const { opsLoading, classesLoading, liveClassesEnrollmentData } = useSelector(
    (state) => state.ops
  );
  const [liveClassesCMS, setLiveClassesCMS] = useState([]);
  const [loading, setLoading] = useState(false);

  const [enrollmentsCount, setEnrollmentsCount] = useState({});
  const countEnrollments = () => {
    const count = {};
    liveClassesEnrollmentData.forEach((item) => {
      if (item?.is_active) {
        if (item?.class_id in count) {
          count[item?.class_id] += 1;
        } else {
          count[item?.class_id] = 1;
        }
      }
    });

    setEnrollmentsCount(count);
    setLoading(false);
  };

  useEffect(() => {
    dispatch(fetchLiveClassesEnrollmentLogic());
    fetchLiveClassesLogic()
      .then((res) => {
        setLiveClassesCMS(res.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
    countEnrollments();
  }, []);

  return (
    <SidebarLayout>
      <section className="contianer-fluid px-5 py-2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Class Enrollments | Precise Digital</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        <div
          className="container-fluid px-3 d-flex justify-content-between"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <OPSPrimaryHeader
            titleText={`Class Enrollments`}
            showSubtitle={false}
            showButton={false}
            showPill={true}
            pillText={`${liveClassesCMS?.length} Entries`}
          />
          <button className="primary-btn d-flex" style={{ gap: "10px" }}>
            <DownloadIcon /> Download
          </button>
        </div>
        {opsLoading || loading || classesLoading ? (
          <PatientLoader />
        ) : (
          <ClassEnrollmentsDataTable
            data={liveClassesCMS}
            enrollmentsCount={enrollmentsCount}
          />
        )}
      </section>
    </SidebarLayout>
  );
};

export default ClassEnrollments;
